import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../hooks'
import { parseServerValidation } from '../../../../utils/validation'
import { getCalendarSettingsPayload } from '../../CalendarSettings.utils'

export function useCalendarSettingsSubmit({ settings, onSave }) {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  async function handleSubmit(values, { resetForm, setErrors, setSubmitting }) {
    return onSave(getCalendarSettingsPayload({ settings, values }))
      .then(() => {
        resetForm({ values })

        handleAddSuccessNotification('Notification.CommonTitleChangedKey')
      })
      .catch(({ response }) => {
        setErrors(
          parseServerValidation(
            response?.data || t('Error.CommonApiRequestFailKey')
          )
        )
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  return { handleSubmit }
}
